// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap'
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faSpinner, faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { faArrowAltCircleDown } from '@fortawesome/free-regular-svg-icons'
import { faTwitter, faFacebookF, faGoogle, faLinkedinIn, faDribbble } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vueSmoothScroll from 'vue-smooth-scroll'

import 'bootstrap/dist/css/bootstrap.css'
import '@/assets/css/main.css'
import '@/assets/css/responsive.css'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import 'owl.carousel'

dom.watch() // This will kick of the initial replacement of i to svg tags and configure a MutationObserver
library.add(faCoffee, faSpinner, faArrowUp, faArrowAltCircleDown)
library.add(faArrowAltCircleDown)
library.add(faTwitter, faFacebookF, faGoogle, faLinkedinIn, faDribbble)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(vueSmoothScroll)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js